module.exports = __webpack_public_path__ + "static/img/PISCI.28e7083.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/PISCI.png
// module id = Zw3J
// module chunks = 1